import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { selectSignUpProperty } from '../../../../redux/auth/selectors';
import { postAuthProperty as actionPostAuthProperty } from '../../../../redux/auth/actions';

import { withRouter, Link } from 'react-router-dom';

/*** Styles */
import containerStyles from './PropertySelect.scss';
import qmStyles from '../../../../theme/qmStyles';

/*** Main components **/
import AddressAutocomplete from '../../../../components/AddressAutocomplete/AddressAutocomplete';
import Button from '../../../../components/Button';
import ContactUs from '../../components/ContactUs';
import { HOUSEHOLD_REQUEST } from '../../config';
import Clickable from '../../../../components/Clickable';
import Checkbox from '../../../../components/Checkbox/Checkbox';

/*** Constants */
import { LABELS } from './PropertySelect.constants';

class PropertySelect extends Component {
  static propTypes = {
    propertyData: PropTypes.shape({
      address_line1: PropTypes.string.isRequired,
    }).isRequired,

    postAuthProperty: PropTypes.func.isRequired,
    navigateNext: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    const { propertyData } = props;

    if (!propertyData) return null;

    this.state = {
      address: propertyData.address_line1,

      addressData: propertyData || {},
      entryMode: false,

      error: null,
    };
  }

  postData = () => {
    const { postAuthProperty, navigateNext } = this.props;
    const { addressData } = this.state;

    // create property here
    const payload = {
      address_line1: addressData.address_line1 || addressData.address,
      city: addressData.city,
      province: addressData.province,
      geo_lat: addressData.geo_lat,
      geo_long: addressData.geo_long,
      postal: addressData.postal,
      apt: addressData.apt || '',
    };

    postAuthProperty(payload)
      .then(data => {
        navigateNext();
      })
      .catch(error => {
        this.setState({
          error: error.data,
        });
      });
  };

  toggleEntry = () => {
    this.setState(prevState => ({
      entryMode: !prevState.entryMode,
    }));
  };

  renderCard = () => {
    const { addressData } = this.state;
    return (
      <div className={containerStyles.addressBox}>
        <h4 className={containerStyles.confirmAddress}>
          {LABELS.CONFIRM_ADDRESS}
        </h4>
        {addressData.street_number && addressData.street ? (
          <h3 className={containerStyles.addressInfo}>
            {`${addressData.street_number || ''} ${
              !!addressData.apt ? addressData.apt : ''
            } ${addressData.street || ''}`}
          </h3>
        ) : (
          <h3 className={containerStyles.addressInfo}>
            {!!addressData.apt ? `#${addressData.apt}, ` : ''}{' '}
            {addressData.address_line1}
          </h3>
        )}
      </div>
    );
  };

  renderEntry = () => {
    const { address } = this.state;
    return (
      <>
        <AddressAutocomplete
          address={address}
          required
          onAddressChange={addressObj => {
            this.setState({ address: addressObj.full_address });
          }}
          onAddressFinalized={addressParts => {
            this.setState({ addressData: addressParts });
          }}
          inputStyle={{ marginBottom: qmStyles.gutter, paddingRight: 30 }}
        />
      </>
    );
  };

  render() {
    const { entryMode } = this.state;

    return (
      <div className={containerStyles.container}>
        <h3 className={containerStyles.title}>{LABELS.SELECT_PROPERTY}</h3>

        {entryMode ? this.renderEntry() : this.renderCard()}
        <Button
          onClick={this.postData}
          text={LABELS.VERIFY}
          style={{
            width: 360,
            marginTop: 24,
            fontSize: 16,
            color: qmStyles.white,
            border: 0,
            borderRadius: 0,
            backgroundColor: qmStyles.qmBabyGreen,
            marginBottom: qmStyles.doubleGutter,
          }}
        />
        {/* <Clickable onClick={this.toggleEntry}>Edit Property</Clickable> */}
        <div className={containerStyles.joinContainer}>
          <p className={containerStyles.joinText}>{LABELS.ALREADY_ON_QM}</p>
          <Link to={HOUSEHOLD_REQUEST}>
            <Button
              text={LABELS.JOIN_HOUSEHOLD}
              style={{
                marginTop: qmStyles.gutter,
                marginBottom: 21,
                width: 360,
                border: `1px solid ${qmStyles.qmGreen}`,
                color: qmStyles.qmGreen,
              }}
            />
          </Link>
          <ContactUs />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  propertyData: selectSignUpProperty(state),
});

const bindAction = {
  postAuthProperty: actionPostAuthProperty,
};

export default withRouter(
  connect(
    mapStateToProps,
    bindAction,
  )(PropertySelect),
);
